export const getUTCOffset = () => {
  const offSetMinutes = new Date().getTimezoneOffset() / -60;
  return `UTC${
    offSetMinutes > 0
      ? `+${offSetMinutes}`
      : offSetMinutes < 0
      ? offSetMinutes
      : ""
  }`;
};
